import React, {useCallback, useEffect, useState} from "react";
import {Grid} from "@mui/material";
import {StyledButton} from "../../../components/ui-base/button";
import {useHistory} from "react-router-dom";
import {toggleLoader} from "../../../store/global/global-slice";
import {useDispatch} from "react-redux";
import {PublisherService} from "../../../services/publisher.service";
import {PublisherSimilarBookModel} from "../../../models/publisher/publisher-similar-book.model";
import {SimilarBookViewList} from "../../../components/publisher/similar-books/similar-book-view-list";
import {PaginationModel} from "../../../models/pagination.model";
import {EmptyBookShort} from "../../../components/author/books/empty-book-short";
import styled from "styled-components";
import Background1 from "../../../img/foreign-book-background-1.png";
import Background2 from "../../../img/foreign-book-background-2.png";
import {useTranslation} from "react-i18next";

const PublisherSimilarBooksListPage = () => {
    const [books, setBooks] = React.useState<PaginationModel<PublisherSimilarBookModel[]>>(null);
    const [exampleBooks, setExampleBooks] = React.useState<PaginationModel<PublisherSimilarBookModel[]>>(null);
    const [loaded, setLoaded] = useState(false);
    const history = useHistory();
    const { t } = useTranslation(['publisher', 'common']);
    const dispatch = useDispatch();

    const loadBooks = useCallback(async (page = 0, perPage = 8) => {
        dispatch(toggleLoader(true));

        const booksRes = await PublisherService.getPublisherBooks(page, perPage);
        setBooks(prevState => {
            return {
                ...booksRes,
                results: (prevState?.results) ? [...prevState.results, ...booksRes.results] : booksRes.results
            };
        });

        setLoaded(true);
        dispatch(toggleLoader(false));
    }, [dispatch]);

    const loadExampleBooks = useCallback(async (page = 0, perPage = 4) => {
        dispatch(toggleLoader(true));

        const booksRes = await PublisherService.getPublisherExampleBooks(page, perPage);
        setExampleBooks(prevState => {
            return {
                ...booksRes,
                results: (prevState?.results) ? [...prevState.results, ...booksRes.results] : booksRes.results
            };
        });

        dispatch(toggleLoader(false));
    }, [dispatch]);

    useEffect(() => {
        loadBooks();
        loadExampleBooks();
    }, [loadBooks, loadExampleBooks]);

    const loadNextBooks = () => {
        if (books.next) {
            loadBooks(books.results.length / 8, 8);
        }
    }

    return (
        <Grid container direction={"column"}>
            {exampleBooks?.results?.length > 0 &&
            <StyledMainGrid container direction={"row"} alignContent={"center"}>
                <Grid container direction={"row"} spacing={2}>
                    {exampleBooks.results.map((book) => (
                        <SimilarBookViewList key={book.id} book={book} exampleBook={true}/>
                    ))}
                    {exampleBooks.results.map((book) => (
                        <SimilarBookViewList key={book.id} book={book} exampleBook={true}/>
                    ))}
                    {exampleBooks.results.map((book) => (
                        <SimilarBookViewList key={book.id} book={book} exampleBook={true}/>
                    ))}
                    {exampleBooks.results.map((book) => (
                        <SimilarBookViewList key={book.id} book={book} exampleBook={true}/>
                    ))}
                </Grid>

                <StyledBackground1 src={Background1}/>
                <StyledBackground2 src={Background2}/>
            </StyledMainGrid>
            }


            <Grid item container justifyContent={"space-between"} alignItems={"center"}>
                <StyledH6>{t('myBooks.yoursBook')}</StyledH6>
                <StyledButton type={"button"} style={{marginRight: '1rem'}} onClick={() => {
                    history.push('/publisher/similar-books/add');
                }}>{t('myBooks.addBook')}
                </StyledButton>
            </Grid>

            {books &&
            <Grid container direction={"row"} spacing={2}>
                {books.results.map((book) => (
                    <SimilarBookViewList key={book.id} book={book}/>
                ))}
            </Grid>
            }

            {books && books.next &&
            <Grid container direction={"row"} justifyContent={"center"} style={{marginTop: '30px'}}>
                <StyledButton type={"button"} color={"transparent"} onClick={() => {loadNextBooks()}}>
                    {t('myBooks.loadNext')}
                </StyledButton>
            </Grid>
            }

            {books && books.results.length === 0 && loaded &&
            <EmptyBookShort
                title={t('myBooks.empty')}
                description={''}
                showButton={false}
            />
            }
        </Grid>
    )
}

const StyledMainGrid = styled(Grid)`
  position: relative;
  min-height: 320px;
  background: #FFFFFF;
  border-radius: 4px;
  padding: 0 10px;
  border: 1px solid #E0E0E0;
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.12));
  overflow: hidden;
  margin-bottom: 20px;
`;

const StyledBackground1 = styled('img')`
  position:absolute;
  top: -20px;
  right: -250px;
  z-index: -1;
`;

const StyledBackground2 = styled('img')`
  position:absolute;
  top: -80px;
  right: -50px;
  z-index: -2;
`;

const StyledH6 = styled('h6')`
  font-size: 1.2rem;
`;

export default PublisherSimilarBooksListPage;
